"use client";

import React from "react";
import { Mail, MapPin, Send, LoaderCircle, ArrowRight } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
function ContactFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="295" className="flex flex-col items-center justify-center h-full min-h-[400px] text-center space-y-6 animate-in fade-in zoom-in duration-500">
        <div className="size-20 rounded-sm bg-secondary/20 flex items-center justify-center text-secondary shadow-[0_0_30px_-5px_var(--color-secondary)]">
          <Send className="size-10" />
        </div>
        <h3 className="text-3xl font-bold text-white tracking-tighter">PROJECT INITIATED</h3>
        <p className="text-muted-foreground max-w-xs mx-auto font-sans">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Full Name</FormLabel>
              <FormControl>
                <input {...field} placeholder="ALEXANDER MOON" className="w-full bg-transparent border-b border-white/10 py-3 text-white placeholder:text-white/10 focus:border-secondary focus:outline-none focus:shadow-[0_10px_20px_-10px_var(--color-secondary)] transition-all duration-500" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Email Address</FormLabel>
              <FormControl>
                <input {...field} type="email" placeholder="ALEX@MOONDOS.COM" className="w-full bg-transparent border-b border-white/10 py-3 text-white placeholder:text-white/10 focus:border-secondary focus:outline-none focus:shadow-[0_10px_20px_-10px_var(--color-secondary)] transition-all duration-500" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="phone" rules={{
      pattern: {
        value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
        message: "Invalid phone number"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Company Name <span className="text-[10px] opacity-40 ml-1">(Optional)</span></FormLabel>
            <FormControl>
              <input {...field} type="text" placeholder="YOUR AGENCY OR BRAND" className="w-full bg-transparent border-b border-white/10 py-3 text-white placeholder:text-white/10 focus:border-secondary focus:outline-none focus:shadow-[0_10px_20px_-10px_var(--color-secondary)] transition-all duration-500" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-muted-foreground font-mono text-xs uppercase tracking-widest">Project Description</FormLabel>
            <FormControl>
              <textarea {...field} rows={4} placeholder="Describe your vision, goals, and timeline..." className="w-full bg-transparent border-b border-white/10 py-3 text-white placeholder:text-white/10 focus:border-secondary focus:outline-none focus:shadow-[0_10px_20px_-10px_var(--color-secondary)] transition-all duration-500 resize-none" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-sm text-destructive text-xs font-mono">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-16 text-sm font-bold tracking-[0.2em] uppercase bg-primary hover:bg-white/90 text-primary-foreground rounded-sm shadow-xl hover:shadow-2xl transition-all duration-500 relative overflow-hidden group">
        {isSubmitting ? <>
            <LoaderCircle className="mr-2 size-4 animate-spin" />
            INITIATING...
          </> : <>
            LET&apos;S BUILD SOMETHING GREAT
            <ArrowRight className="ml-3 size-4 group-hover:translate-x-2 transition-transform duration-500" />
          </>}
        <div className="absolute inset-0 bg-secondary/10 translate-y-full group-hover:translate-y-0 transition-transform duration-700 skew-y-6" />
      </Button>
    </Form>;
}
export default function StartAConversation() {
  return;
}